import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text'

import ImgTermConditionTNCList from 'assets/icons/img-term-condition-tnc-list.svg'

const steps = [
  {
    title: 'Diskusi dengan atasan',
    description:
      'Lakukan diskusi sebelum batas waktu agar perencanaan Anda dapat segera disetujui.',
  },
  {
    title: 'Persetujuan dan penyesuaian dari atasan',
    description:
      'Berdasarkan diskusi, atasan lalu akan menyetujui dan memberikan penyesuaian jika diperlukan.',
  },
  {
    title: 'Lanjut ke kesepakatan, lalu laksanakan!',
    description:
      'Sepakati perencanaan yang disetujui oleh atasan. Lalu, Anda bisa langsung ke tahap berikutnya: Pelaksanaan.',
  },
]

interface TabRangkumanWaitingApprovalProps {
  onClickBackToHome?: () => any
}

const TabRangkumanWaitingApproval = ({
  onClickBackToHome = () => {},
}: TabRangkumanWaitingApprovalProps) => {
  return (
    <div className="p-9 flex justify-center">
      <div className="w-[500px] p-9 flex flex-col">
        <ImgTermConditionTNCList width={84} height={84} />

        <Text variant="heading-lg" className="mt-4">
          Perencanaan Kinerja berhasil diajukan! Tahap selanjutnya adalah:
        </Text>

        <div className="flex flex-col gap-4 mt-4">
          {steps.map(({ title, description }, i) => (
            <div key={title} className="flex gap-2">
              <div className="flex justify-center items-center bg-gray-80 rounded-full p-3 self-start">
                <Text variant="body-sm" color="inverse" className="absolute">
                  {i + 1}
                </Text>
              </div>
              <div className="flex flex-col gap-1">
                <Text variant="action">{title}</Text>
                <Text variant="body-sm" color="subdued">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </div>

        <Button
          size="lg"
          color="black"
          className="mt-4"
          fullWidth
          onClick={onClickBackToHome}
        >
          Kembali ke Beranda
        </Button>
      </div>
    </div>
  )
}

export default TabRangkumanWaitingApproval
